const NAMESPACE = 'developer-drawer';

export const SET_DEVELOPER_DRAWER_OPEN = `${NAMESPACE}/SET_DEVELOPER_DRAWER_OPEN`;
export const SET_DEVELOPER_DRAWER_HEIGHT = `${NAMESPACE}/SET_DEVELOPER_DRAWER_HEIGHT`;
export const SET_DEVELOPER_DRAWER_WIDTH = `${NAMESPACE}/SET_DEVELOPER_DRAWER_WIDTH`;
export const SET_DEVELOPER_DRAWER_HORIZONTAL = `${NAMESPACE}/SET_DEVELOPER_DRAWER_HORIZONTAL`;
export const SET_DEVELOPER_DRAWER_CURRENT_TAB = `${NAMESPACE}/SET_DEVELOPER_DRAWER_CURRENT_TAB`;
